function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#E65300;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.3,8.2L9.8,4.2c0-0.4,0-0.7,0.1-0.9c0.2-0.2,0.4-0.2,0.6-0.2h0V2.6H8.4l0,0.1c0.1,0.5,0,1-0.3,1.7 C7.8,5.2,7.2,6.4,6.4,8C6.1,7.3,5.9,6.7,5.5,6.1C5,5,4.4,3.8,4.3,2.7V2.6H2.2v0.5h0c0.2,0,0.4,0.1,0.6,0.2C3,3.6,3,3.9,2.9,4.4 L2.4,8.2c-0.1,0.7-0.4,1-0.9,1h0v0.5h2.5V9.1H3.8C3.6,9.2,3.3,9,3.1,8.9C2.9,8.6,2.9,8.3,3,7.7l0.5-3.5C3.8,5.2,4.2,6,4.7,6.9 c0.5,1,1,2,1.1,2.7v0h0.6v0c0.1-0.7,0.6-1.5,1-2.4c0.5-0.9,0.9-1.8,1.2-2.7l0.5,3.7c0.1,0.3,0,0.5-0.2,0.8C8.7,9.1,8.5,9.2,8.3,9.1 h0v0.5h3.1V9.1h0C10.6,9.1,10.4,8.7,10.3,8.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.5,8.4c-0.3,0.3-0.8,0.5-1.2,0.5c-0.4,0-0.9-0.2-1.2-0.5c-0.4-0.4-0.6-0.9-0.5-1.5h3.2V6.8 c0-1.1-0.9-1.9-1.9-1.9c-1.2,0-2.2,1.1-2.2,2.5s0.9,2.4,2.2,2.4c0.8,0,1.5-0.4,1.9-1.1l0,0L15.5,8.4L15.5,8.4z M13.6,5.4 c0.5,0,0.8,0.4,0.9,1h-2C12.7,5.7,13.1,5.4,13.6,5.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M21.4,9c-0.2,0-0.4,0-0.4-0.5v-6h-0.3l-1.4,0.4v0.3l0.7,0.4V5c-0.3-0.1-0.7-0.2-1.1-0.2c-1.4,0-2.5,1.2-2.5,2.7 c0,1.2,0.9,2.2,2,2.2c0.6,0,1.2-0.3,1.6-0.7v0.7h0.3l1.4-0.3V8.9l-0.1,0C21.6,9,21.5,9,21.4,9z M18.8,5.4c0.5,0,1.3,0.3,1.3,1.6v1.4 C19.8,8.8,19.4,9,19,9c-1.1,0-1.5-1.2-1.5-2C17.5,6.1,18.1,5.4,18.8,5.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23.9,3.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0 C23.3,3.4,23.5,3.7,23.9,3.7C23.9,3.7,23.9,3.7,23.9,3.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M24.4,8.4V4.9h-0.3l-1.4,0.5v0.3l0.8,0.4v2.4c0,0.3-0.2,0.6-0.6,0.7c0,0-0.1,0-0.1,0h-0.1v0.5H25V9.2H25 C24.6,9.1,24.4,8.9,24.4,8.4z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M29.9,3.3c0-0.5-0.5-0.8-1.2-0.8c-1.2,0-2,0.8-2,2.1c0,0.3-0.1,0.4-0.5,0.4h-0.3v0.6h0.8v2.9 c0,0.5-0.2,0.7-0.8,0.7h-0.1v0.5h2.8V9.2h-0.1c-0.9,0-1-0.2-1-0.8V5.6h1.2V5h-1.2V3.9c0-0.7,0.4-0.9,0.6-0.9s0.4,0.2,0.5,0.4 s0.3,0.4,0.6,0.4C29.6,3.8,29.8,3.6,29.9,3.3C29.9,3.3,29.9,3.3,29.9,3.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M33.4,8.3L33.4,8.3c-0.4,0.3-0.8,0.5-1.3,0.5c-0.4,0-0.9-0.2-1.2-0.5c-0.4-0.4-0.6-0.9-0.5-1.5h3.2V6.8 c0-1.1-0.9-1.9-1.9-1.9c-1.2,0-2.2,1.1-2.2,2.5s0.9,2.4,2.1,2.4c0.8,0,1.5-0.4,1.9-1.1l0,0L33.4,8.3z M31.6,5.4c0.5,0,0.8,0.4,0.9,1 h-2C30.6,5.7,31,5.4,31.6,5.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "33.4,2.6 32.1,2.6 31,4.2 31.4,4.2 "
});

function SvgNuevoLogoMedife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.1 12.4",
    style: {
      enableBackground: "new 0 0 35.1 12.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuevoLogoMedife);
export default __webpack_public_path__ + "static/media/nuevo_logo_medife.d40aa97c.svg";
export { ForwardRef as ReactComponent };